import { db } from '../firebaseConfig';
import { collection, getDocs, doc, updateDoc } from 'firebase/firestore';

export const resetAllDreamCounters = async () => {
    try {
        // Get all users
        const usersSnapshot = await getDocs(collection(db, 'profiles'));
        
        // Reset counter for each user
        const resetPromises = usersSnapshot.docs.map(async (userDoc) => {
            const userRef = doc(db, 'profiles', userDoc.id);
            return updateDoc(userRef, {
                postCount: 0
            });
        });

        await Promise.all(resetPromises);
        console.log('Successfully reset all dream counters');
        return true;
    } catch (error) {
        console.error('Error resetting dream counters:', error);
        return false;
    }
};

// Function to reset a specific user's dream counter
export const resetUserDreamCounter = async (userId) => {
    try {
        const userRef = doc(db, 'profiles', userId);
        await updateDoc(userRef, {
            postCount: 0
        });
        console.log(`Successfully reset dream counter for user ${userId}`);
        return true;
    } catch (error) {
        console.error('Error resetting user dream counter:', error);
        return false;
    }
};
